<template>
    <div id="main-panel" class="col-sm-6 col-sm-offset-3 col-md-10 col-md-offset-2 main">
        <h2>Setting</h2>
        <ul class="list-group">
            <li class="list-group-item">
                <button id="setting-team-name" type="button" class="btn btn-raised btn-link" v-on:click="$emit('show-team-form')">Team Setting</button>
            </li>
            <li class="list-group-item">
                <button id="setting-calendar-apikey" type="button" class="btn btn-raised btn-link" v-on:click="$emit('show-calendar-form')">Google Calendar Setting</button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    // methods: {
    //     showTeamForm: function() {
    //         this.$emit('show-team-form')
    //     },
    //     showCalendarForm: function() {
    //         this.$emit('show-calendar-form')
    //     }
    // }
}
</script>

<style>
</style>
